import { NotificationApi } from '@calm/evexia-web-sdk/generated/lib/api/notification-api';
import { createApi } from './create-api';

/**
 * Helper function to configure and create a new instance of `NotificationApi`
 * @param accessToken
 * @returns
 */
export default function createNotificationApi(
    accessToken: () => Promise<string>
) {
    return createApi(NotificationApi, accessToken);
}
